import {
    onJSBridgeConnected,
    onAdShow,
    onAdShowTemp,
    fetchInitData,
    readyToShowAD,
    failureToShowAD,
    broadcast,
    onBroadcast,
    closeAd,
    bannerFetchInitData,
    bannerReadyToShowAD
} from "../api";
import VConsole from 'vconsole'
import Unit from "./Unit";
import Webview from "./component/native/visible/Webview";
import {getUrlParams, fireEvent, getAllAdOptions} from "../common/util";
import { fullScreenShow } from "../api/nativeComponentAPI";
import {initNonBizReporter} from "../common/m_common/mNonBizReport";
import messageConfig from '../class/FrameMessage/config.js'
import EventManager from "../common/EventManager";


(function(window){
    let temp = window.console
    window.consolebak = temp
    window.console = {
        log: function(){},
        warn: function(){},
        error: function(){},
        info: temp.info
    }
    const query = getAllAdOptions()
    if(query && query.consolelog === '1'){
        window.console = temp
    }
})(window);

let vConsole
function getVConsoleInstance(){
    vConsole = vConsole || new VConsole()
    return vConsole
}

let viewComponentMap = {}
window.__vcm = viewComponentMap
document.addEventListener('nativeComponentCreated', function(event){
    const { id, instance } = event.param
    viewComponentMap[id] = instance
})
document.addEventListener('ContainerViewCreated', function(event){
    const { id, instance } = event.param
    viewComponentMap[id] = instance
});


// 直接注册onAdShow可能会因注册时机过晚而遗漏（webviewshow已触发之后再注册的情况），
// 所以添加该方法在已触发webviewshow之后注册仍可响应到webviewshow事件
const whenAdShow = (function () {
    let cbCatch = []
    let isShowed = false
    let result = null
    console.log('webviewshow之前',location.href)

    function fire (res, from) {
        console.log('... webviewshow',res, cbCatch, from, location.href)
        cbCatch.forEach(item => {
            item(res)
        })
        cbCatch = []
    }

    (function(){
        let called = false
        onAdShow((data) => {
            if(called===false) {
                console.log('--onAdShow ============>', data, location.href)
                App.broadcast('MTG_AdShow', data)
                called = true

                console.log('... webviewshow',cbCatch, location.href)
                isShowed = true
                result = data
                fire(data, 'onAdShow')
            }else{
                console.log('--onAdShow already called ============>', data, location.href)
            }
        })
    })()

    //监听从父window视图发来的webviewshow
    window.addEventListener('message', (e)=>{
        if(result){
            //当前模板已触发过adshow，子模板不会走到当前if分支
            return;
        }
        const {action, data} = e.data
        if(action==='webviewshow'){
            console.log("iframe ... MTG_AdShow webviewshow====>",e, location.href)
            ///fireEvent('webviewshow', data)
            fire(data, 'addEventListener')
        }
    })

    onBroadcast('MTG_AdShow',(event) => {
        console.log('... 接收到广播 MTG_AdShow',location.href)
        const { data } = event
        fire(data, 'onBroadcast')
    })

    return function (cb) {
        if (isShowed) {
            cb(result)
        } else {
            cbCatch.push(cb)
        }
    }
})();


whenAdShow(data=>{
    App.adShowTime = Date.now()
})


const eventManager = new EventManager()


// 上层视图(window)展示或隐藏处于iframe中的当前视图时，会发送onContainerShow及onContainerHide事件给当前视图
;(function(){
    window.addEventListener('message', (e)=>{
        const {action, data} = e.data
        if(action==='onContainerShow'){
            eventManager.fire('onContainerShow')
        }else if(action==='onContainerHide'){
            eventManager.fire('onContainerHide')
        }
    })

})();


const App =  {
    unit:{},

    onContainerShow: (cb)=>{
        eventManager.registerLast('onContainerShow', cb)
    },
    onContainerHide: (cb)=>{
        eventManager.registerLast('onContainerHide', cb)
    },

    enableDebugMode() {
        getVConsoleInstance()
    },

    onJSBridgeConnected: (cb)=>{
        const query = getUrlParams()
        if(query.createByIframe === 'true'){
            cb()
        }else{
            return onJSBridgeConnected(cb)
        }
    },
    readyToShowAD(...args){
        //if(called===true)return;
        console.log('readyToShowAD!!!!!!!!!!!!!!!!!', args, location.href)
        if(top === window){
            console.log('触发-readyToShowAD!!!!!!!!!!!!!!!!!', args, location.href)
            readyToShowAD(...args)
        }
        //called = true
    },
    failureToShowAD(...args){
        console.log('failureToShowAD!!!!!!!!!!!!!!!!!', args, location.href)
        if(top === window){
            console.log('触发-failureToShowAD!!!!!!!!!!!!!!!!!', args, location.href)
            failureToShowAD(...args)
        }
    },
    broadcast,
    onBroadcast,
    bannerReadyToShowAD,
    closeAd(delay=200){
        console.log('触发关闭广告', location.href)
        eventManager.fire('adClosed')
        setTimeout(() => {
            closeAd(this.unit.id || this.initData && this.initData.unit_id, App.rootViewId)
        }, delay)
    },
    onAdShow(cb){
        /*console.log('App -> sbd 注册 onAdShow')
        onBroadcast('MTG_AdShow',(event) => {
            console.log('接收到广播 MTG_AdShow')
            const { data } = event
            cb(data)
        })*/
        whenAdShow(data=>{
            cb && cb(data)
        })
    },
    onAdClose(cb){
        eventManager.register('adClosed', cb)
    },
    //收到父视图发来的消息
    /*onWebviewPostMessage(cb) {
        onBroadcaonAdClosest('webviewPostMessage', (event)=>{
            console.log('收到postmessage', event, this,this.rootWebview)
            const { data={} } = event
            if(data.id === this.rootWebview.id){
                cb && cb(data.data)
            }
        })
    },
    //收到子视图向父视图发来的送消息
    onEmitMessage(eventName, cb) {
        onBroadcast('webviewEmitMessage', (event)=>{
            // console.log('收到EmitMessage',event,nativeComponentMap,nativeComponentMap[event.data.id],eventName,event.data.eventName)
            const { data={} } = event
            if(nativeComponentMap[data.id] && data.id!==this.rootWebviewId && eventName===data.eventName){
                console.warn('收到指定的 ==》 EmitMessage', event,nativeComponentMap,nativeComponentMap[data.id],eventName,data.eventName)
                cb && cb(data.data)
            }
        })
    },
    //向父视图发送消息
    emitMessage(eventName, params={}) {
        const _params = {
            id: this.rootWebview.id,
            eventName,
            data: {
                ...params
            }
        }
        return broadcast('webviewEmitMessage', _params)
    },*/


    fullScreenShow(componentId) {
        console.log('fullScreenShow :: ',componentId)
        return new Promise(resolve => {
            console.log("fullScreenShow---",this.initData)
            if(this.initData.sdkSetting.isRootTemplateWebView){
                let device = this.initData.device
                let width = +device.screen_width
                let height = +device.screen_height
                console.log("fullScreenShow---",width,height,device)
                //{ top:0, height, left:0, width }
                fullScreenShow(componentId, this.rootWebviewId).then(()=>{
                    resolve()
                })
            }else{
                this.emitMessage('MTG_fullScreenShow', {
                    componentId
                })
            }
        })
    },

    loadTemplate({ templateClass, templateLoader, loadCallback, fetchFun, adStateClass, reporterClass }){
        const tplLoader = new templateLoader()

        return tplLoader.loadTemplate(templateClass, adStateClass, reporterClass, (data)=>{
            this.iframeViewId = tplLoader.getIframeViewId()
            this.rootViewId = tplLoader.getRootViewId()
            this.rootView = tplLoader.getRootView()
            this.rootWebviewId = tplLoader.getRootWebviewId()
            this.rootWebview = tplLoader.getRootWebview()
            this.unit = tplLoader.getUnit()
            this.initData = tplLoader.getInitData()

            console.log('messageConfig.setConfig',{
                webviewId: this.rootWebviewId,
                iframeViewId:this.iframeViewId,
                //unitId: this.unit.id,
                viewMap: viewComponentMap,
                nativeBroadcastAPI:'VideoBridge/broadcast',
                nativeBroadcastParamFilter:data=>{
                    return {
                        unitId: this.unit.id,
                        ...data
                    }
                },
                callNative: undefined,
            }, this, location.href)
            messageConfig.setConfig({
                webviewId: this.rootWebviewId,
                iframeViewId:this.iframeViewId,
                //unitId: this.unit.id,
                viewMap: viewComponentMap,
                nativeBroadcastAPI:'VideoBridge/broadcast',
                nativeBroadcastParamFilter:data=>{
                    return {
                        unitId: this.unit.id,
                        ...data
                    }
                },
                callNative: undefined,
            })

            // 初始化非业务埋点
            initNonBizReporter({initData: this.initData})

            loadCallback(data)
        }, fetchFun)
    }
};



// App.onEmitMessage('MTG_fullScreenShow', (event)=>{
//     console.log('MTG_fullScreenShow ============>', event)
//     /*setTimeout(()=>{
//         App.fullScreenShow(event.componentId)
//     },4e3)*/
//     App.fullScreenShow(event.componentId)
// })


export default App